{
  "familyId": "REK-HANDIG-DEEL",
  "questions": [
    {
      "id": "REK-HANDIG-DEEL-001",
      "familyId": "REK-HANDIG-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "handig",
      "subSkill": "handig_delen",
      "questionType": "multiple_choice",
      "question": "Reken handig uit: 360 ÷ 15. Welke manier is het handigst?",
      "options": [
        "Factoren: 360 ÷ 15 = 360 ÷ 3 ÷ 5 = 120 ÷ 5 = 24",
        "Staartdeling: 36 ÷ 15 = 2 rest 6, dan 60 ÷ 15 = 4 → 24",
        "Herhaald aftrekken: 360 − 15 − 15 − 15 ... (24 keer)",
        "Halveren: 360 ÷ 2 = 180, dan 180 ÷ 7,5 = 24"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Delen via factoren",
            "content": "15 = 3 × 5. Dus 360 ÷ 15 = 360 ÷ 3 ÷ 5. Eerst: 360 ÷ 3 = 120. Dan: 120 ÷ 5 = 24. Door de deler in factoren te splitsen, maak je twee makkelijke delingen!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_deel_factoren",
      "variantIndex": 1,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "360 ÷ 15 = 24. Handig: splits 15 in factoren: 15 = 3 × 5. Eerst 360 ÷ 3 = 120, dan 120 ÷ 5 = 24. Door de deler in factoren te splitsen, maak je twee makkelijke delingen in plaats van één moeilijke.",
        "solutionSteps": [
          "Herken factoren: 15 = 3 × 5",
          "360 ÷ 3 = 120",
          "120 ÷ 5 = 24"
        ],
        "distractorExplanations": {
          "0": "Goed! 360 ÷ 3 = 120, dan 120 ÷ 5 = 24. Factoren splitsen is hier de handigste manier.",
          "1": "Staartdeling werkt, maar is meer werk. Met factoren (÷3, dan ÷5) heb je twee eenvoudige stappen.",
          "2": "Herhaald aftrekken is de langzaamste manier — je moet 24 keer aftrekken! Factoren splitsen is veel sneller.",
          "3": "Halveren en dan door 7,5 delen maakt het juist moeilijker. 7,5 is geen handig getal. Factoren (3 × 5) zijn veel makkelijker."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.strategy-suboptimal", "label": "Kiest staartdeling i.p.v. handig", "optionIndex": 1 },
          { "id": "rek.strategy-suboptimal", "label": "Kiest herhaald aftrekken", "optionIndex": 2 },
          { "id": "rek.strategy-suboptimal", "label": "Kiest halveren bij oneven deler", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-HANDIG-DEEL-002",
      "familyId": "REK-HANDIG-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "handig",
      "subSkill": "handig_delen",
      "questionType": "multiple_choice",
      "question": "Reken handig uit: 480 ÷ 12",
      "options": ["40", "48", "42", "38"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Halveren als strategie",
            "content": "480 ÷ 12: halveer beide getallen! 480 ÷ 2 = 240, en 12 ÷ 2 = 6. Nu: 240 ÷ 6 = 40. Of via factoren: 12 = 4 × 3, dus 480 ÷ 4 = 120, dan 120 ÷ 3 = 40.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_deel_halveren",
      "variantIndex": 2,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "480 ÷ 12 = 40. Handig: halveer beide getallen: 480 ÷ 2 = 240, 12 ÷ 2 = 6. Nu: 240 ÷ 6 = 40. Of via factoren: 12 = 4 × 3, dus 480 ÷ 4 = 120, dan 120 ÷ 3 = 40.",
        "solutionSteps": [
          "Strategie: halveer beide getallen",
          "480 ÷ 2 = 240, 12 ÷ 2 = 6",
          "240 ÷ 6 = 40"
        ],
        "distractorExplanations": {
          "0": "Goed! 480 ÷ 12 = 40. Halveren maakt de deling makkelijker.",
          "1": "Je verwisselde deeltal en deler: 480 ÷ 10 = 48, maar de deler is 12, niet 10. 480 ÷ 12 = 40.",
          "2": "Je dacht waarschijnlijk 480 ÷ 12 ≈ 42. Maar 42 × 12 = 504 ≠ 480. Controleer: 40 × 12 = 480. ✓",
          "3": "Je dacht waarschijnlijk 480 ÷ 12 ≈ 38. Maar 38 × 12 = 456 ≠ 480. Controleer: 40 × 12 = 480. ✓"
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.context-wrong-data", "label": "Deelt door 10 i.p.v. 12", "optionIndex": 1 },
          { "id": "rek.calculation-error", "label": "Deelfout: 480÷12≈42", "optionIndex": 2 },
          { "id": "rek.calculation-error", "label": "Deelfout: 480÷12≈38", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-HANDIG-DEEL-003",
      "familyId": "REK-HANDIG-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "handig",
      "subSkill": "handig_delen",
      "questionType": "fill_in",
      "question": "Reken handig uit: 750 ÷ 25",
      "options": [],
      "correctAnswer": "30",
      "data": {
        "acceptedAnswers": ["30"]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Delen door 25 = × 4 ÷ 100",
            "content": "Delen door 25 is hetzelfde als vermenigvuldigen met 4 en dan delen door 100. 750 × 4 = 3.000, dan 3.000 ÷ 100 = 30. Of: 750 ÷ 25 = 750 ÷ 5 ÷ 5 = 150 ÷ 5 = 30.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_deel_25_truc",
      "variantIndex": 3,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "750 ÷ 25 = 30. Handige truc: ÷ 25 = × 4 ÷ 100. Dus 750 × 4 = 3.000, dan 3.000 ÷ 100 = 30. Of via factoren: 25 = 5 × 5, dus 750 ÷ 5 = 150, dan 150 ÷ 5 = 30.",
        "solutionSteps": [
          "Strategie: ÷ 25 = × 4 ÷ 100",
          "750 × 4 = 3.000",
          "3.000 ÷ 100 = 30"
        ]
      }
    },
    {
      "id": "REK-HANDIG-DEEL-004",
      "familyId": "REK-HANDIG-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "handig",
      "subSkill": "handig_delen",
      "questionType": "multiple_choice",
      "question": "Een sportvereniging verdeelt €1.800 gelijk over 12 teams. Hoeveel krijgt elk team? Reken handig.",
      "options": ["€150", "€160", "€145", "€180"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Handig delen in context",
            "content": "1.800 ÷ 12: splits 12 = 4 × 3. Eerst 1.800 ÷ 4 = 450. Dan 450 ÷ 3 = 150. Of halveer: 1.800 ÷ 2 = 900, 12 ÷ 2 = 6. Nu: 900 ÷ 6 = 150.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_deel_context",
      "variantIndex": 4,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "€1.800 ÷ 12 = €150. Handig: splits 12 in factoren: 12 = 4 × 3. Eerst 1.800 ÷ 4 = 450, dan 450 ÷ 3 = 150. Elk team krijgt €150.",
        "solutionSteps": [
          "Herken: €1.800 ÷ 12 teams",
          "Factoren: 12 = 4 × 3",
          "1.800 ÷ 4 = 450",
          "450 ÷ 3 = 150"
        ],
        "distractorExplanations": {
          "0": "Goed! €1.800 ÷ 12 = €150 per team. Dat klopt helemaal.",
          "1": "Je dacht waarschijnlijk 1.800 ÷ 12 ≈ 160. Maar 160 × 12 = 1.920 ≠ 1.800. Controleer: 150 × 12 = 1.800. ✓",
          "2": "Je dacht waarschijnlijk 1.800 ÷ 12 ≈ 145. Maar 145 × 12 = 1.740 ≠ 1.800. Controleer: 150 × 12 = 1.800. ✓",
          "3": "Je deelde waarschijnlijk door 10 in plaats van 12: 1.800 ÷ 10 = 180. Maar er zijn 12 teams, niet 10. 1.800 ÷ 12 = 150."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.calculation-error", "label": "Deelfout: 1800÷12≈160", "optionIndex": 1 },
          { "id": "rek.calculation-error", "label": "Deelfout: 1800÷12≈145", "optionIndex": 2 },
          { "id": "rek.context-wrong-data", "label": "Deelt door 10 i.p.v. 12", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-HANDIG-DEEL-005",
      "familyId": "REK-HANDIG-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "handig",
      "subSkill": "handig_delen",
      "questionType": "multiple_choice",
      "question": "Reken handig uit: 2.400 ÷ 16. Welke manier is het handigst?",
      "options": [
        "Herhaald halveren: 2.400 ÷ 2 = 1.200, ÷ 2 = 600, ÷ 2 = 300, ÷ 2 = 150",
        "Factoren: 2.400 ÷ 4 = 600, dan 600 ÷ 4 = 150",
        "Staartdeling: 24 ÷ 16 = 1 rest 8, dan 80 ÷ 16 = 5 ... → 150",
        "Compenseren: 2.400 ÷ 20 = 120, dan bijstellen → 150"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Herhaald halveren bij machten van 2",
            "content": "16 = 2 × 2 × 2 × 2. Dus ÷ 16 = vier keer halveren! 2.400 → 1.200 → 600 → 300 → 150. Dit is de snelste strategie als de deler een macht van 2 is.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_deel_herhaald_halveren",
      "variantIndex": 5,
      "citoDifficulty": 0.54,
      "citoDiscrimination": 0.82,
      "feedback": {
        "explanationText": "2.400 ÷ 16 = 150. Herhaald halveren is hier het handigst: 16 = 2⁴, dus halveer vier keer. 2.400 → 1.200 → 600 → 300 → 150. Dit werkt altijd als de deler een macht van 2 is (2, 4, 8, 16, 32...).",
        "solutionSteps": [
          "Herken: 16 = 2 × 2 × 2 × 2",
          "2.400 ÷ 2 = 1.200",
          "1.200 ÷ 2 = 600",
          "600 ÷ 2 = 300",
          "300 ÷ 2 = 150"
        ],
        "distractorExplanations": {
          "0": "Goed! Vier keer halveren: 2.400 → 1.200 → 600 → 300 → 150. Slim!",
          "1": "Factoren (÷ 4 ÷ 4) werkt ook en geeft hetzelfde antwoord. Maar herhaald halveren is nóg eenvoudiger — je hoeft alleen maar te halveren.",
          "2": "Staartdeling werkt, maar is veel meer werk. Herhaald halveren is sneller en minder foutgevoelig.",
          "3": "Compenseren (÷ 20 = 120, dan bijstellen) is hier lastig — je moet uitrekenen hoeveel je moet bijstellen. Herhaald halveren is directer."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.strategy-suboptimal", "label": "Kiest factoren i.p.v. halveren", "optionIndex": 1 },
          { "id": "rek.strategy-suboptimal", "label": "Kiest staartdeling i.p.v. handig", "optionIndex": 2 },
          { "id": "rek.strategy-suboptimal", "label": "Kiest compenseren bij deling", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-HANDIG-DEEL-006",
      "familyId": "REK-HANDIG-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "handig",
      "subSkill": "handig_delen",
      "questionType": "number_sequence",
      "question": "Vul de reeks aan. We delen steeds door 2 (halveren).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "sequence": [3200, 1600, 800, null, 200, null],
        "acceptedAnswers": [["400", "100"]]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Herhaald halveren",
            "content": "Als je deelt door 2, neem je de helft. 800 ÷ 2 = 400. En 200 ÷ 2 = 100.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_deel_halveren_reeks",
      "variantIndex": 6,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "De regel in deze reeks is: deel door 2 (halveren). De helft van 800 is 400. De helft van 200 is 100.",
        "solutionSteps": [
          "Stap 1: 800 ÷ 2 = 400",
          "Stap 2: 200 ÷ 2 = 100"
        ]
      }
    }
  ]
}